var map = {
	"./color.yml": 37,
	"./country.yml": 38,
	"./doc.yml": 39,
	"./emoji.yml": 40,
	"./git.yml": 41,
	"./icon.yml": 42,
	"./license.yml": 43,
	"./link.yml": 44,
	"./people.yml": 45,
	"./services.yml": 46,
	"./soft.yml": 47,
	"./src.yml": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;